import { render, staticRenderFns } from "./TheAppSideBar.vue?vue&type=template&id=90e79174&scoped=true&"
import script from "./TheAppSideBar.vue?vue&type=script&lang=js&"
export * from "./TheAppSideBar.vue?vue&type=script&lang=js&"
import style0 from "./TheAppSideBar.vue?vue&type=style&index=0&id=90e79174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e79174",
  null
  
)

export default component.exports